/* WALQO: a fail-closed, success-only fallback; never race the Google App pixel. */
(() => {
  if (window.__walqoAtcFallbackV1) return;
  window.__walqoAtcFallbackV1 = true;
  const destination = 'G-TM80BWME5E';
  const seen = new WeakSet();

  function ownership() {
    // Read the server-rendered WPM configuration, not timing/gtag availability.
    for (const script of document.scripts) {
      const match = (script.textContent || '').match(/webPixelsConfigList:\s*(\[.*?\]),isMerchantRequest:/s);
      if (!match) continue;
      try {
        const pixels = JSON.parse(match[1]);
        const google = pixels.filter((pixel) => String(pixel.apiClientId) === '1780363');
        if (google.length !== 1) return 'unknown';
        const config = JSON.parse(JSON.parse(google[0].configuration).config);
        if (!Array.isArray(config.gtag_events) || config.enable_monitoring_mode !== false) return 'unknown';
        const events = config.gtag_events.filter((event) => event.type === 'add_to_cart');
        if (events.some((event) => [event.action_label].flat().includes(destination))) return 'app';
        // Fallback is allowed only with an explicit Google configuration that excludes this target.
        return 'fallback';
      } catch (_) { return 'unknown'; }
    }
    return 'unknown';
  }

  document.addEventListener('walqo:cart-add-success', (event) => {
    try {
      const form = event.target;
      const currency = form?.dataset?.walqoAtcCurrency;
      const detail = event.detail;
      if (!currency || !detail || typeof detail !== 'object' || seen.has(detail)) return;
      seen.add(detail);
      if (ownership() !== 'fallback') return;
      if (typeof window.gtag !== 'function') return;
      // Respect Shopify consent. Unknown consent is not permission to send.
      if (window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() !== true) return;
      const item = detail.item;
      const quantity = Number(detail.quantity);
      if (!item || item.status || Array.isArray(item.items) || String(item.variant_id || item.id) !== String(detail.variantId)) return;
      if (!/^[A-Z]{3}$/.test(currency) || !Number.isInteger(quantity) || quantity < 1) return;
      if (!Number.isFinite(item.final_price) || item.final_price < 0 || !item.product_id) return;
      const price = item.final_price / 100;
      const value = Math.round(item.final_price * quantity) / 100;
      const id = `shopify_ZZ_${item.product_id}_${detail.variantId}`;
      window.gtag('event', 'add_to_cart', {
        send_to: destination, currency, value,
        items: [{ item_id: id, item_name: item.product_title, item_brand: item.vendor,
          item_category: item.product_type || '', item_variant: item.variant_title || '', price, quantity }],
        ecomm_prodid: [id], ecomm_totalvalue: value, ecomm_pagetype: 'product'
      });
    } catch (_) { /* Analytics errors must not affect shopping. */ }
  });
})();
